import {FC, PropsWithChildren, useState} from "react";
//import Lightbox from "react-18-image-lightbox";
//import 'react-18-image-lightbox/style.css';
import {useFileUrl} from "@hooks/filesHooks";
//import FsLightbox from "fslightbox-react"
import "yet-another-react-lightbox/styles.css";
import Lightbox, {Slide} from "yet-another-react-lightbox";
import Video from "yet-another-react-lightbox/plugins/video";
import {getAttachmentTypeByExtension} from "@services/helpers";
import {AttachmentType} from "@interfaces/user/support";

interface LightBoxProps {
    image?: string;
    fileId?: string;
}

const LightBox: FC<PropsWithChildren<LightBoxProps>> = ({image, fileId, children}) => {

    const [isOpen, setIsOpen] = useState(false);

    let src = useFileUrl(fileId, image).replace(":443", "");
    const type = getAttachmentTypeByExtension(src);

    const slides: Slide[] = type === AttachmentType.Image ? [{type: "image", src}] : [
        {
            type: "video",
            sources: [
                {
                    src: src,
                    type: "video/mp4"
                }
            ]
        }
    ];

    return (
        <>
            <div className="cursor-pointer" onClick={() => setIsOpen(true)}>
                {children}
            </div>
            {/*{isOpen && (*/}
            {/*    <Lightbox*/}
            {/*        mainSrc={src}*/}
            {/*        onCloseRequest={() => setIsOpen(false)}*/}
            {/*        reactModalStyle={{ overlay: { zIndex: 999999 } }}*/}
            {/*        onImageLoad={() => {*/}
            {/*            window.dispatchEvent(new Event('resize'));*/}
            {/*        }}*/}
            {/*    />*/}
            {/*)}*/}
            <Lightbox
                open={isOpen}
                close={() => setIsOpen(false)}
                plugins={[Video]}
                slides={slides}
            />
        </>
    )
}

export default LightBox;